.path {
  display: flex;
  align-items: stretch;
  gap: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  overflow-x: auto;
}

.step {
  display: flex;
  /* A station is as wide as its own name and shares what is left. It was `flex: 1 1 0; min-width: 0`, so at
     1024 a filing row's three stations were cut to "Che…", "App…" and "Iss…" (G-Wviewer-13, -24, G-Wapprover-27).
     A path that is too wide for its place scrolls (`.path` is `overflow-x: auto`) and never loses a word. */
  flex: 1 1 auto;
  min-width: min-content;
}

/* The chevron: a bordered block with a pointed right edge, drawn with a clip so the hairline follows
   the point. The point is decoration; the order is the list's. */
.chevron {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1 1 auto;
  min-width: 0;
  min-height: 28px;
  padding: 0 16px 0 20px;
  background: var(--panel-2);
  color: var(--muted);
  font-size: var(--t-dense);
  font-weight: 600;
  clip-path: polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%, 10px 50%);
  white-space: nowrap;
}

.step:first-child .chevron {
  padding-left: 14px;
  clip-path: polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%);
}

.step + .step {
  margin-left: -4px;
}

.mark {
  flex: 0 0 auto;
}

.label {
  min-width: 0;
}

.step[data-state="done"] .chevron {
  background: var(--ok-w);
  color: var(--ok);
}

.step[data-state="current"] .chevron {
  background: var(--accent);
  color: var(--on-fill);
}

.step[data-state="blocked"] .chevron {
  background: var(--crit-w);
  color: var(--crit);
}

.step[data-state="unknown"] .chevron {
  background: var(--warn-w);
  color: var(--warn);
}

/* The filing path draws the current station larger: it is where the person's next action is. That is
   the first station not done (`data-here`), blocked or not checked as well as in progress. */
.emphasised .step[data-state="current"],
.emphasised .step[data-here] {
  flex-grow: 1.6;
}

.emphasised .step[data-state="current"] .chevron,
.emphasised .step[data-here] .chevron {
  min-height: 40px;
  font-size: var(--t-body);
}
